export default __webpack_public_path__ + "static/media/AntofagastaMineralsLogo.a7da76ff.svg";